var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        ref: "query_model",
        attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.updateImg }
            },
            [_vm._v("上传")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small swb-btn-primary",
              on: {
                click: function($event) {
                  _vm.setAttTag($event)
                }
              }
            },
            [_vm._v("批量设置标签")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.servcWorkImgList.length > 0
        ? _c(
            "ul",
            { staticClass: "file-area input clearfix" },
            _vm._l(_vm.servcWorkImgList, function(servcWorkImg, index) {
              return _c(
                "li",
                {
                  staticClass: "file-content clearfix",
                  class: { active: _vm.ids.indexOf(servcWorkImg.id) != -1 },
                  staticStyle: { height: "100%" }
                },
                [
                  servcWorkImg.merchantType == _vm.merchantType
                    ? _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            _vm.selectCheck(servcWorkImg.id)
                          }
                        },
                        model: {
                          value: _vm.checkBox[servcWorkImg.id],
                          callback: function($$v) {
                            _vm.$set(_vm.checkBox, servcWorkImg.id, $$v)
                          },
                          expression: "checkBox[servcWorkImg.id]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("swb-file-item", {
                    attrs: {
                      trackKey: index,
                      fileName: servcWorkImg.fileName,
                      fileUuid: servcWorkImg.fileUuid,
                      fileBrowseUrl: servcWorkImg.fileBrowseUrl,
                      fileDownloadUrl: servcWorkImg.fileDownLoadUrl,
                      fileMd5: servcWorkImg.fileMd5,
                      deletable: servcWorkImg.merchantType == _vm.merchantType,
                      onDelete: _vm.deleteFile
                    }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      title: servcWorkImg.desc,
                      disabled: true,
                      placeholder: "文件名称不可多于50个字"
                    },
                    on: {
                      input: function($event) {
                        _vm.changeDesc(index)
                      }
                    },
                    model: {
                      value: servcWorkImg.desc,
                      callback: function($$v) {
                        _vm.$set(servcWorkImg, "desc", $$v)
                      },
                      expression: "servcWorkImg.desc"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(servcWorkImg.ts))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt5" }, [
                    servcWorkImg.tagName != null
                      ? _c(
                          "i",
                          { staticClass: "swb-tags swb-tags-success mr5" },
                          [_vm._v(_vm._s(servcWorkImg.tagName))]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  servcWorkImg.merchantType == _vm.merchantType
                    ? _c("div", { staticClass: "mt5" }, [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.enditImg(servcWorkImg.id)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        servcWorkImg.shared == false
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-link ml10",
                                on: {
                                  click: function($event) {
                                    _vm.doShareImg(servcWorkImg.id, true)
                                  }
                                }
                              },
                              [_vm._v("共享")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        servcWorkImg.shared == true
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-link ml10",
                                on: {
                                  click: function($event) {
                                    _vm.doShareImg(servcWorkImg.id, false)
                                  }
                                }
                              },
                              [_vm._v("取消共享")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-layout" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "prev, pager, next, jumper, sizes, total"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        { ref: "attPopoverRef", attrs: { classes: "popper-tabs" } },
        [
          _c("swb-att-tag-list-for-select", {
            ref: "swb_att_tag_list_for_select",
            attrs: { attAspect: _vm.attAspect, selectName: _vm.tagName },
            on: {
              "notity-attTag-comfirm": _vm.doAttTagConfirm,
              "notity-attTag-cancel": _vm.doAttTagCancel
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da566200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da566200","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherImgList.vue
// module id = 2857
// module chunks = 0